<div class="avs-dashboard-title">
    <h6>Brennstoffzellen Füllstände <button class="ms-2" mat-stroked-button (click)="getDetails()">Details</button></h6>
</div>
<div>
    <canvas class="avs-dashboard-canvas" id="FuelCellRemainingChart">{{ chart }}</canvas>
</div>